/* import __COLOCATED_TEMPLATE__ from './favicon.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { type InterfaceIconName } from '@intercom/pulse/lib/interface-icons';

interface Signature {
  Element: HTMLImageElement;
  Args: {
    url?: string;
    fallbackIcon?: InterfaceIconName;
  };
}

export default class Favicon extends Component<Signature> {
  @tracked faviconError = false;

  @action handleFaviconError() {
    this.faviconError = true;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Common::Favicon': typeof Favicon;
    'common/favicon': typeof Favicon;
  }
}
